import { UserStore } from "./user"

export const STORE_USER = 'user'

export const stores = {
    [STORE_USER]:new UserStore()
}